export const ROLES = {

}

export const PERMISSIONS = {
    // ADMIN
    FINANCIAL_APPROVAL: 'financial approval',
    MODIFY_DEALERS: 'modify dealers',
    MODIFY_DISCOUNTS: 'modify discounts',
    MODIFY_INTEGRATIONS: 'modify integrations',
    MODIFY_LEADS: 'modify leads',
    MODIFY_ORDERS: 'modify orders',
    MODIFY_PRICES: 'modify prices',
    MODIFY_PRODUCTIONS: 'modify productions',
    MODIFY_PURCHASING: 'modify purchasing',
    MODIFY_SETTINGS: 'modify settings',
    MODIFY_STOCKS: 'modify stocks',
    MODIFY_USERS: 'modify users',
    VIEW_DEALERS: 'view dealers',
    VIEW_DISCOUNTS: 'view discounts',
    VIEW_EMAIL_LOGS: 'view email logs',
    VIEW_INTEGRATIONS: 'view integrations',
    VIEW_LEADS: 'view leads',
    VIEW_ORDERS: 'view orders',
    VIEW_PRICES: 'view prices',
    VIEW_PRODUCTIONS: 'view productions',
    VIEW_PURCHASING: 'view purchasing',
    VIEW_SETTINGS: 'view settings',
    VIEW_STOCKS: 'view stocks',
    VIEW_USERS: 'view users',
    // FINANCIAL CONTROLLER

    APPROVE_ORDERS_AT_FINANCIAL_STAGE: 'approve orders at financial stage',
    COMMUNICATE_WITH_DEALERS: 'communicate with dealers',
    FINANCIAL_APPROVAL: 'financial approval',
    FINANCIAL_CONTROLLER_DASHBOARD: 'financial controller dashboard',
    HOLD_ORDERS_AT_FINANCIAL_STAGE: 'hold orders at financial stage',
    MODIFY_DEALERS: 'modify dealers',
    MODIFY_DISCOUNTS: 'modify discounts',
    MODIFY_LEADS: 'modify leads',
    MODIFY_ORDERS: 'modify orders',
    RECEIVE_FINANCIAL_DIGEST: 'receive financial digest',
    REJECT_ORDERS_AT_FINANCIAL_STAGE: 'reject orders at financial stage',
    VIEW_DEALERS: 'view dealers',
    VIEW_DISCOUNTS: 'view discounts',
    VIEW_LEADS: 'view leads',
    VIEW_ORDERS: 'view orders',

}